import template from './panel.html'
import css from './panel.css'
import { PanelController } from './panel.controller.js'

export const PanelComponent = {
  template: template,
  controller: PanelController,
  controllerAs: 'PanelController',
  transclude: true,
  bindings: {
    strtitle: '@',
    size: '@',
    panelid:'@'
  },
  require: {
    parentPanel: '^^panelContainer',
    parentSimulator: '^^simulatorComponent'
  }
}



// WEBPACK FOOTER //
// ./src/client/common/uiComponents/Panel/panel.component.js